import { render } from "./imgAndContentFullWidth.vue?vue&type=template&id=56b7f375&scoped=true"
import script from "./imgAndContentFullWidth.vue?vue&type=script&lang=js"
export * from "./imgAndContentFullWidth.vue?vue&type=script&lang=js"

import "./imgAndContentFullWidth.vue?vue&type=style&index=0&id=56b7f375&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b7f375"]])

export default __exports__